/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ taken: NonNullable<unknown>, total: NonNullable<unknown> }} Platform_Widget_SeatsInputs */

const en_platform_widget_seats = /** @type {(inputs: Platform_Widget_SeatsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.taken}/${i?.total} spots`)
};

const pl_platform_widget_seats = /** @type {(inputs: Platform_Widget_SeatsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.taken}/${i?.total} miejsc`)
};

/**
* | output |
* | --- |
* | "{taken}/{total} spots" |
*
* @param {Platform_Widget_SeatsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_widget_seats = /** @type {((inputs: Platform_Widget_SeatsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Widget_SeatsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_widget_seats(inputs)
	return en_platform_widget_seats(inputs)
});